export default {
      id: "icon_apple-usage",
      viewBox: "0 0 30 30",
      url: __webpack_public_path__ + "sprite.svg#icon_apple",
      toString: function () {
        return this.url;
      }
    }